import { render, staticRenderFns } from "./information.vue?vue&type=template&id=4bffff27&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=4bffff27&prod&lang=scss"
import style1 from "./information.vue?vue&type=style&index=1&id=4bffff27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bffff27",
  null
  
)

export default component.exports